import React from "react";

export const LOGO_URL =
  "https://customer-assets-lqy194kg.emergentagent.net/job_dentist-appointments-7/artifacts/aop4lrbk_image.png";

// DotMedy.com logo
const Logo = ({ size = "md", dark = false }) => {
  const heights = { sm: "h-8", md: "h-11", lg: "h-14", xl: "h-20" };
  const h = heights[size] || heights.md;
  return (
    <img
      src={LOGO_URL}
      alt="DotMedy.com — Hi-Octane Practice"
      className={`${h} w-auto object-contain ${dark ? "brightness-0 invert" : ""}`}
      draggable={false}
    />
  );
};

export default Logo;
